import { store } from "../../model/DataManager.js";
import { Language } from "../../model/Language.js";
import { VOVideo } from "../../model/Structure.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlSidebar extends BaseControl {

    private onActiveChange = e5.Signal.create<[ControlSidebar]>();

    private _list: HTMLElement;
    private _listContent: HTMLElement;
    private _active: boolean = false;
    private _current: VOVideo = null;
    private _items: ControlSidebarItem[] = [];

    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                icon: "fal fa-sidebar-flip",
                position: ControlPosition.RIGHT,
                // visible: false,
                tooltip: Language.resolve("Videoliste", "Video list"),
                onInit: (item) => {
                    const updateSelected = () => {
                        item.selected = this.active;
                    }
                    updateSelected();
                    this.onActiveChange.add(updateSelected);
                },
                onClick: (item) => {
                    this.active = !this.active;
                }
            }
        );

        this._list = document.createElement("div");
        this._list.classList.add("sidebar-list");
        this.pano.element.appendChild(this._list);

        this._listContent = document.createElement("div");
        this._listContent.classList.add("sidebar-list-content");
        this._list.appendChild(this._listContent);

        for (var group of store.config.groups) {
            var gr = document.createElement("div");
            gr.classList.add("group");
            gr.style.backgroundColor = group.color;
            this._listContent.appendChild(gr);

            if (group.title_de || group.title_en || group.icon) {

                var header = document.createElement("div");
                header.classList.add("group-header");
                gr.appendChild(header);

                if (group.icon) {
                    var groupIcon = document.createElement("div");
                    groupIcon.classList.add("group-icon", "icon-" + group.icon);
                    header.appendChild(groupIcon);
                }

                if (group.title_de || group.title_en) {
                    var groupTitle = document.createElement("div");
                    groupTitle.classList.add("group-title");
                    Language.apply(groupTitle, group.title_de, group.title_en);
                    header.appendChild(groupTitle);
                }
            }
            else {
                gr.classList.add("no-header");
            }

            var groupItems = document.createElement("div");
            groupItems.classList.add("group-items");
            gr.appendChild(groupItems);

            for (var v of group.videos) {
                this.addItem(v, groupItems);
            }
        }

        pano.onChangeVideo.add((video) => {
            this.current = video;
        });
    }

    private get current(): VOVideo {
        return this._current;
    }

    private set current(video: VOVideo) {
        if (this._current === video)
            return;

        if (this._current) {
            for (var item of this._items)
                if (item.video === this._current)
                    item.element.classList.remove("selected");
        }
        this._current = video;
        if (this._current) {
            for (var item of this._items)
                if (item.video === this._current)
                    item.element.classList.add("selected", "checked");
        }
    }

    protected get active(): boolean {
        return this._active;
    }

    protected set active(active: boolean) {
        if (this._active === active)
            return;
        this._active = active;
        this._list.classList.toggle("active", active);
        this.pano.element.classList.toggle("sidebar-open", active);
        this.onActiveChange.dispatch(this);
    }

    private addItem(video: VOVideo, group: HTMLElement): void {
        var item = new ControlSidebarItem(video, this.pano);
        group.appendChild(item.element);
        this._items.push(item);
    }
}

class ControlSidebarItem {
    public element: HTMLElement;
    public video: VOVideo;

    constructor(video: VOVideo, public pano: Pano) {
        this.video = video;

        this.element = document.createElement("div");
        this.element.className = "item";
        this.element.setAttribute("tabindex", "0");

        this.element.addEventListener("keydown", (e) => {
            if (e.repeat) {
                return;
            }
            if (e5.KeyCode.is(e, e5.KeyCode.SPACE, e5.KeyCode.ENTER)) {
                this.trigger();
            }
        });

        if (video.video_desktop && video.video_desktop.sizes && video.video_desktop.sizes.medium) {
            this.element.style.backgroundImage = "url(" + video.video_desktop.sizes.medium + ")";
        } else {
            var icon = document.createElement("div");
            icon.className = "icon icon-789";
            this.element.appendChild(icon);
        }

        var label = document.createElement("div");
        label.className = "label";
        Language.apply(label, video.title_de, video.title_en);
        this.element.appendChild(label);

        var checked = document.createElement("div");
        checked.className = "icon-check icon-437";
        this.element.appendChild(checked);

        this.element.addEventListener("click", (e) => {
            this.trigger();
        });
    }

    private trigger():void{
        this.pano.load(this.video.id, "sitemap");
    }
}